<template>
  <div v-if="detailData.operation" class="suitable">
    <div v-if="describes">
      <h2 class="suitable-title">
        {{ $t('coursesDetail.suitable') }}
      </h2>
      <div v-if="placement.describe" class="go-test" @click="goTest()">
        <p v-html="placement.describe" />
        <i v-if="placement.link" class="iconfont icon-arrow-right-outline" />
      </div>
      <!-- 香港账号切换提示 -->
      <div v-if="$store.state.locale == 'hk'" class="go-test" @click="goChangeAccount()">
        <p v-html="$t('coursesDetail.noticeDescribe')" />
        <i class="iconfont icon-arrow-right-outline" />
      </div>
      <div class="mb12">
        <div v-for="(item,index) in describes" :key="index" class="suitable-desc ">
          <p>
            {{ item }}
          </p>
        </div>
      </div>
      <div v-if="illustrations" class="suitable-img">
        <img
          v-lazy-load :data-src="illustrations"
          alt=""
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    detailData: {
      type: Object,
      default: () => ([]),
    },
  },
  data() {
    return {
      isObject: false,
    }
  },
  computed: {
    operation() {
      return JSON.parse(this.detailData.operation || '{}')
    },
    placement() {
      return this.operation.staticData.portrait.placement
    },
    describes() {
      return this.operation.staticData.portrait.describes
    },
    illustrations() {
      return this.operation.staticData.portrait.illustrations[0]
    },
  },
  methods: {
    goTest() {
      if (this.placement.link) {
        window.open(this.placement.link)
      }
    },
    goChangeAccount() {
      this.$router.push('/my-account')
    },
  },

}
</script>
<style lang="scss" scoped>
.suitable {
  .suitable-title {
    margin-bottom: 10px;
    margin-top: 40px;
    font-size: 32px;
    font-weight: 600;
    color: rgba(23, 43, 77, 1);
    line-height: 33px;
  }

  .suitable-desc {
    width: 780px;
    font-size: 18px;
    font-weight: 500;
    color: rgba(23, 43, 77, 1);
    line-height: 24px;
  }

  .mb12 {
    margin-bottom: 12px;
  }

  .go-test {
    position: relative;
    display: flex;
    align-items: center;
    width: 780px;
    margin-bottom: 12px;
    padding: 8px 56px 8px 16px;
    box-sizing: border-box;
    background: #fff;
    font-size: 16px;
    border-radius: 10px;
    color: var(--txt-color-lv1);
    font-weight: 500;
    cursor: pointer;
    white-space: pre-line;

    i {
      position: absolute;
      right: 16px;
      font-size: 12px;
      font-weight: 700;
      color: var(--txt-color-lv2);
    }
  }

  .suitable-img {
    width: 380px;
    height: auto;

    img {
      width: 100%;
      border-radius: 10px;
      filter: alpha(opacity=10);
    }
  }
}
</style>
